import api from '../../utils/helpers/api';

import * as constants from '../../utils/constants/constant';

export const getListCampaign = (data = {}) => {
  const option = {
    method: 'post',
    url: '/customer-engagement/aff/get-affiliation-campaign-statistic',
    data,
  };
  return api(option);
};

export const createCampaign = (data = {}) => {
  const option = {
    method: 'post',
    url: '/customer-engagement/aff/create-affiliation-campaign',
    data,
  };
  return api(option);
};

export const getUserAffiliationInfo = (headers = {}) => {
  const option = {
    method: 'get',
    url: '/customer-engagement/aff/get-my-affiliation-info',
    headers,
  };
  return api(option);
};

export const getCampaign = (aff_cid = '') => {
  const option = {
    method: 'get',
    url: `/customer-engagement/aff/get-affiliation-info?aff_cid=${aff_cid}`,
  };
  return api(option);
};

export const updateCampaign = (data = {}) => {
  const option = {
    method: 'post',
    url: `/customer-engagement/aff/update-affiliation-campaign`,
    data,
  };
  return api(option);
};

export const getListPromotion = () => {
  const option = {
    method: 'get',
    url: '/customer-engagement/aff/get-my-promotion-codes',
  };
  return api(option);
};

export const updateMyInfo = (data = {}) => {
  const option = {
    method: 'post',
    url: '/customer-engagement/aff/update-my-affiliation-info',
    data,
  };
  return api(option);
};

export const uploadImage = (data = {}) => {
  const option = {
    method: 'post',
    url: '/assets/file/upload',
    data,
    severVice: constants.AFF_ASSES_UPLOAD,
  };
  return api(option);
};

export const updateBrandingImage = (data = {}) => {
  const option = {
    method: 'post',
    url: '/customer-engagement/aff/upload-branding-image',
    data,
  };
  return api(option);
};

export const getIncomeStatic = (data = {}) => {
  const option = {
    method: 'post',
    url: '/customer-engagement/aff/get-income-statistic',
    data,
  };
  return api(option);
};

export const getIncomeStaticDetail = (data = {}) => {
  const option = {
    method: 'post',
    url: '/customer-engagement/aff/get-income-detail',
    data,
  };
  return api(option);
};

export const getListDomain = () => {
  const option = {
    method: 'get',
    url: '/customer-engagement/aff/get-affiliation-domains',
  };
  return api(option);
};
export const getCommissionHistoryDetail = () => {
  const option = {
    method: 'get',
    url: '/customer-engagement/aff/get-commission-history-by-user',
  };
  return api(option);
};
